// http://autotest.hunliji.com/#/home/project/api/edit?projectId=-701335349&apiId=203424&moduleid=2525 scope 字段
export const COUPON_SCOPE_MEAL = 2 // 指定套餐可用
